(function clearCartOnLoad() {
  'use strict';
  fetch('/cart.js')
    .then((response) => {
      if (!response.ok) {
        throw new Error('Failed to fetch cart');
      }
      return response.json();
    })
    .then((cart) => {
      if (cart && cart.item_count > 0) {
        return fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error('Failed to clear cart');
            }
            return response.json();
          })
          .then(() => {
            window.location.reload();
          });
      }
    })
    .catch((error) => {
      console.error('Cart initialization error:', error);
    });
})();
